import { i18n } from '@/plugins/element'
const { t } = i18n.global

// 租户状态
const tenantStatus = [
  {
    id: 'activated',
    name: t('user.enabled')
  },
  {
    id: 'forbidden',
    name: t('user.disabled')
  }
]
// 试用状态
const trialStatus = [
  {
    id: 'false',
    name: t('user.untrialed')
  },
  {
    id: 'true',
    name: t('user.trialed')
  }
]
// 角色
const rolesOptions = [
  {
    id: 'admin',
    name: t('user.administrators')
  },
  {
    id: 'enterprise',
    name: t('user.tenant_administrator')
  },
  {
    id: 'read_only',
    name: t('user.read_only')
  },
  {
    id: 'operator',
    name: t('user.operator')
  }
]
// AK/SK状态
const akskStatusOptions = [
  {
    id: 'enabled',
    name: t('user.enabled')
  },
  {
    id: 'disabled',
    name: t('user.disabled')
  }
]
export {
  tenantStatus,
  trialStatus,
  rolesOptions,
  akskStatusOptions
}